import { ANNOUNCEMENT_FAILURE,ANNOUNCEMENT_DELETE,ANNOUNCEMENT_SUCCESS,ANNOUNCEMENT_REQUEST, UPDATE_REQUEST, UPDATE_SUCCESS, UPDATE_FAILURE, UPDATE_DELETE} from '../Constants/ActionTypes';
 import { toast } from "react-toastify";
import * as API from '../API/api.js';


export const announcementDetails = (values ,token)=> async dispatch => {
    try {
      dispatch({ type: ANNOUNCEMENT_REQUEST });
      const data = await API.postAnnouncement(values,token);
      if (data) {
        dispatch({ type: ANNOUNCEMENT_SUCCESS, payload: data });
          // navigate('/')
          toast("Announcement Added Successfully")
      }
    } catch (error) {
      toast('DATA NOT DISPATCHED');
      dispatch({ type: ANNOUNCEMENT_FAILURE });
    }
  };
  
  export const announcementDelete = (values ,token)=> async dispatch => {
    try {
      dispatch({ type: ANNOUNCEMENT_DELETE });
      const data = await API.deleteAnnouncement(values,token);
      console.log(data);
      if (data) {
        dispatch({ type: ANNOUNCEMENT_DELETE, payload: data });
          // navigate('/')
          toast("Announcement Deleted Successfully")
          console.log(data);
      }
    } catch (error) {
      toast('Announcement Not Deleted');
      dispatch({ type: ANNOUNCEMENT_FAILURE });
    }
  };
  

  export const uploadDetail = (values ,token)=> async dispatch => {
    try {
      dispatch({ type: UPDATE_REQUEST });
      const data = await API.postUdaptes(values,token);
      if (data) {
        dispatch({ type: UPDATE_SUCCESS, payload: data });
          // navigate('/')
          toast("Update Added Successfully")
      }
    } catch (error) {
      toast('DATA NOT DISPATCHED');
      dispatch({ type: UPDATE_FAILURE });
    }
  };

  export const deleteUpdate = (values ,token)=> async dispatch => {
    try {
      dispatch({ type: UPDATE_DELETE });
      const data = await API.deleteUpdateAPI(values,token);
      console.log(data);
      if (data) {
        dispatch({ type: UPDATE_DELETE, payload: data });
          // navigate('/')
          toast("Update Deleted Successfully")
          console.log(data);
      }
    } catch (error) {
      toast('Update Not Deleted');
      dispatch({ type: UPDATE_FAILURE });
    }
  };



  
  export const fetchAnnouncementData = () => async dispatch => {
    try {
      dispatch({ type: ANNOUNCEMENT_REQUEST });
      const data = await API.fetchAnnouncement();
      // console.log(data);
      if (data) {
        dispatch({ type: ANNOUNCEMENT_SUCCESS, payload: data });
      }
     
    } catch (error) {
      toast('ERROR IN FETCHING ANNOUNCEMENT');
      console.log(error)
      dispatch({ type: ANNOUNCEMENT_FAILURE });
    }
  };